import React, { useEffect } from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import BackButton from '../components/common/BackButton';

const Disclosures = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <BackButton />
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
              Disclosures & Compliance
            </h1>

            <div className="space-y-8">
              {/* DSA Identity */}
              <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-lg">
                <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontSize: '18px' }}>
                  DSA Identity & Authorization
                </h2>
                <p className="text-gray-800 leading-relaxed" style={{ fontSize: '14px' }}>
                  <strong>Prajwal Jadhav and Nikita Bansod / Shravi Finance</strong> (Individual DSA) is an authorised Direct Selling Agent (DSA) / Channel Partner for RBI-regulated banks and NBFCs such as <strong>SBI, HDFC Bank, Bajaj Finserv, etc.</strong>
                  <br /><br />
                  We only assist in connecting customers with lenders. We do not provide loans directly.
                </p>
              </div>

              {/* Lender Responsibility */}
              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-lg">
                <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontSize: '18px' }}>
                  Lender & RBI Responsibility
                </h2>
                <p className="text-gray-800 leading-relaxed" style={{ fontSize: '14px' }}>
                  All loans are sanctioned exclusively by RBI-regulated partner banks/NBFCs.
                  Interest rates, EMIs, processing fees, tenure, and approval are governed by RBI Digital Lending Guidelines and individual lender policies.
                  <strong> We do not guarantee loan approval.</strong>
                </p>
              </div>

              {/* Risk Warning */}
              <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-lg">
                <div className="flex items-start gap-3">
                  <span className="text-2xl flex-shrink-0">⚠️</span>
                  <div>
                    <h2 className="text-xl font-bold text-gray-900 mb-2" style={{ fontSize: '18px' }}>
                      Risk Warning
                    </h2>
                    <p className="text-gray-800 leading-relaxed" style={{ fontSize: '14px' }}>
                      Loans involve interest costs and repayment obligations. Borrow responsibly after understanding all charges and terms.
                      Defaulting on loan payments may adversely affect your credit score and financial standing.
                    </p>
                  </div>
                </div>
              </div>

              {/* No Guarantees */}
              <div className="bg-gray-50 border-l-4 border-gray-500 p-6 rounded-lg">
                <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontSize: '18px' }}>
                  No Guarantees
                </h2>
                <p className="text-gray-800 leading-relaxed" style={{ fontSize: '14px' }}>
                  Loan approval depends on lender eligibility criteria, CIBIL score, income, KYC, and documentation.
                  <strong> Not all applicants qualify.</strong> Compliant with RBI Fair Practices Code.
                </p>
              </div>

              {/* Fees Transparency */}
              <div className="bg-green-50 border-l-4 border-green-500 p-6 rounded-lg">
                <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontSize: '18px' }}>
                  Fees & Charges Transparency
                </h2>
                <p className="text-gray-800 leading-relaxed" style={{ fontSize: '14px' }}>
                  Processing fees, prepayment charges, and other costs apply as per lender terms.
                  <strong> No hidden charges.</strong> Compare offers before applying.
                  All fees and charges will be clearly disclosed by the lender before loan disbursement as per RBI guidelines.
                </p>
              </div>

              {/* Data Protection */}
              <div className="bg-purple-50 border-l-4 border-purple-500 p-6 rounded-lg">
                <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontSize: '18px' }}>
                  Data Protection & Privacy (DPDP Act, 2023)
                </h2>
                <p className="text-gray-800 leading-relaxed mb-3" style={{ fontSize: '14px' }}>
                  Your personal information will be shared <strong>ONLY</strong> with selected partner banks/NBFCs for loan processing.
                  We do not sell or misuse your data. Compliant with DPDP Act, 2023 and RBI data protection norms.
                </p>
                <p className="text-gray-700 leading-relaxed" style={{ fontSize: '13px' }}>
                  You have the right to access, correct, or delete your personal data at any time. For more details, please refer to our <a href="#/privacy-policy" className="text-primary-600 hover:underline font-semibold">Privacy Policy</a>.
                </p>
              </div>

              {/* Grievance Redressal */}
              <div className="bg-indigo-50 border-l-4 border-indigo-500 p-6 rounded-lg">
                <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontSize: '18px' }}>
                  Grievance Redressal
                </h2>
                <p className="text-gray-800 leading-relaxed mb-3" style={{ fontSize: '14px' }}>
                  For any complaints or grievances, please contact us at <strong>shravifinance@gmail.com</strong> or call <strong>+91 8668272248</strong> / <strong>+91 7020113728</strong>.
                </p>
                <p className="text-gray-800 leading-relaxed mb-3" style={{ fontSize: '14px' }}>
                  You may also lodge complaints with:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-800 ml-4" style={{ fontSize: '14px' }}>
                  <li>The respective lender directly</li>
                  <li>RBI Sachet Portal: <a href="https://sachet.rbi.org.in/" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline font-semibold">https://sachet.rbi.org.in/</a></li>
                  <li>RBI Complaint Management System: <a href="https://cms.rbi.org.in" target="_blank" rel="noopener noreferrer" className="text-primary-600 hover:underline font-semibold">https://cms.rbi.org.in</a></li>
                </ul>
              </div>

              {/* Compliance */}
              <div className="bg-teal-50 border-l-4 border-teal-500 p-6 rounded-lg">
                <h2 className="text-xl font-bold text-gray-900 mb-3" style={{ fontSize: '18px' }}>
                  Regulatory Compliance
                </h2>
                <p className="text-gray-800 leading-relaxed mb-3" style={{ fontSize: '14px' }}>
                  We operate in compliance with:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-800 ml-4" style={{ fontSize: '14px' }}>
                  <li>RBI Digital Lending Guidelines</li>
                  <li>RBI Fair Practices Code</li>
                  <li>DPDP Act, 2023 (Digital Personal Data Protection Act)</li>
                  <li>Information Technology Act, 2000</li>
                  <li>Meta/Facebook Ads Policies</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Disclosures;

